<template>
  <div class="container">
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input
          v-model="searchText"
          search
          placeholder="搜索记录..."
          @on-change="searchReceive"
          clearable
          icon="ios-search"
          style="width: 250px; margin-right: 20px"
        ></Input>
      </div>
      <div class="handle-right">
        <span>共{{ totalRows }}条</span>
        <Page
          :total="totalRows"
          :page-size="15"
          @on-change="loadSalesPlanReceive"
          show-total
          simple
          style="margin-right: 24px"
        />
      </div>
    </div>
    <h2 class="date">{{ curYear }}年{{ curMonth }}月</h2>
    <div class="table-wrapper" ref="tableWrapper">
      <Table :columns="columns" :data="salesStatReceive" :height="tableHeight">
        <template slot-scope="{ row }" slot="vol">
          <div v-if="volIndexFile !== row._id" @click="show(row, 'transPrice')">
            <div>
              {{
                row.salesStat
                  ? row.salesStat.estReceive
                    ? row.salesStat.estReceive
                    : "-"
                  : "-"
              }}
            </div>
          </div>
          <div v-show="volFile === row._id">
            <Input
              style="width: 100px"
              autofocus
              @on-blur="setVol(row)"
              v-model="editVol"
            />
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { arrayIntersection } from "@/utils";

import dayjs from "dayjs";
const typeToText = {
  trans: "银行转账",
  bankAccBill: "银行承兑汇票",
  commAccBill: "商业承兑汇票",
  check: "支票",
  cash: "现金钞票",
};
export default {
  name: "EditReceivePlan",
  components: {},
  data() {
    return {
      page: 0,
      tableHeight: 300,
      searchText: null,
      tableLoading: false,
      volIndexFile: null,
      volFile: null,
      editVol: null,
      salesStatReceive: [],
      columns: [
        {
          title: "客户",
          key: "sales",
          render: (h, params) =>
            h(
              "span",
              {
                style: {
                  cursor: "pointer",
                  color: "#42b983",
                },
                on: {
                  click: () => {},
                },
              },
              params.row.name
            ),
        },
        {
          title: "应收金额",
          key: "date",
          align: "left",
          render: (h, params) => h("span", ""),
        },
        {
          title: "逾期应收",
          key: "date",
          align: "right",
          render: (h, params) => h("span", ""),
        },
        {
          title: "统计日期",
          key: "date",
          align: "center",
          render: (h, params) => h("span", ""),
        },
        {
          title: "计划回款",
          key: "date",
          align: "right",
          slot: "vol",
          minWidth: 100,
        },
        {
          title: "创建人",
          key: "date",
          align: "right",
          render: (h, params) => h("span", ""),
        },
      ],
      curYear: null,
      curMonth: null,
    };
  },
  sockets: {
    async connect() {
      console.log("connect success");
    },
  },
  computed: mapState({
    totalRows: (state) => state.receive.totalCounts,
  }),
  methods: {
    ...mapActions({
      getSalesStatReceive: "salesStat/getSalesStatReceiveAction",
      postSalesStatReceive: "salesStat/postSalesStatReceiveAction",
    }),
    async loadSalesPlanReceive(page) {
      try {
        let api = {
          skip: this.page * 15,
          limit: 15,
        };
        const date = dayjs(this.pickM).format("YYYY-MM").split("-");
        api.year = date[0];
        api.month = date[1];
        // this.tableLoading = true;
        const data = await this.getSalesStatReceive(api);
        this.salesStatReceive = data.customerList;
        // this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
        // this.tableLoading = false;
      }
    },
    // 切换数据与input的显示
    show(row) {
      this.volIndexFile = row._id;
      this.volFile = row._id;
      this.editVol = row.salesForecast;
    },
    // 失焦时保存数据
    async setVol(row) {
      this.volIndexFile = null;
      this.volFile = null;
      let api = {
        year: Number(this.curYear),
        month: Number(this.curMonth),
        customer: row._id,
      };
      if (this.editVol) {
        api.estReceive = Number(this.editVol);
        await this.postSalesStatReceive(api);
      }
    },
    searchReceive() {},
  },
  created() {
    this.loadSalesPlanReceive();
    this.curYear = this.$route.query.year;
    this.curMonth = this.$route.query.month;
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>
<style lang="stylus" scoped>
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .handle-left
    display flex
    align-items center

  .handle-right
    display flex
    align-items center

    .page-wrap
      display flex
      align-items center

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>